// import { createAsyncThunk } from '@reduxjs/toolkit';
// import { fetchUserFromAPI } from './userAPI'; // Example API call
// import Cookies from "js-cookie";
// import axios from 'axios';
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const fetchIgConversations = createAsyncThunk(
//   'instagram/fetchIgConversations',
//   async (_, { rejectWithValue }) => {
//     try {
//         const response = await axios.get(`${BASE_URL}/ig/Conversation`,{
//             headers:{
//               "Authorization":`Bearer ${ Cookies.get('token')}`
//             }
//           });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue( error?.message|| 'Error fetching Facebook conversations');
//     }
//   }
// );


import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import swal from "sweetalert";

const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API base URL

// Thunks for API calls

export const fetchIgConversations = createAsyncThunk(
  "instagram/fetchConversations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/ig/Conversation`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });

      console.log(response.data.data, "fetchIgConversations");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getIgConversationByUser = createAsyncThunk(
  "instagram/getConversationByUser",
  async ({ currentChatId, page, limit }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/ig/message/${currentChatId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          params: {
            page,
            limit
          }
        }
      );
      console.log(
        response.data.response,
        "response.data.responseresponse.data.responseresponse.data.responseresponse.data.responseresponse.data.response"
      );
      const { data, recipient, senderId } = response.data.response;
      return response.data.response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const igautochat = createAsyncThunk(
  "instagram/igautochat",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/ig/autochat/${data?.currentChatId}`,
        {
          autochat: data?.autochat,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(
        response.data.response,
        "response.data.responseresponse.data.responseresponse.data.responseresponse.data.responseresponse.data.response"
      );
      // const { data, recipient, senderId } = response.data.response;
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const instagramsendmessage = createAsyncThunk(
  "instagram/sendMessage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/ig/message`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response?.data; // Return the response data
    } catch (error) {
      // swal({
      //   title: "message Error",
      //   text: error.response.data.message,
      //   icon: "error",
      //   position: "top",
      //   showConfirmButton: true,
      // });
      // console.log(
      //   error.response.data.message,
      //   "------------------error-------------------------"
      // );
      console.log(error.message, "error.messageerror.message")
      return rejectWithValue(error.message);
    }
  }
);

export const addMediaToInstagram = createAsyncThunk(
  "instagram/addMedia",
  async (data, { rejectWithValue }) => {
    try {
      console.log(data, "imageUrlimageUrl");
      const response = await axios.post(`${BASE_URL}/instagram/addpost`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const publishMediaOnInstagram = createAsyncThunk(
  "instagram/publishMedia",
  async ({ creationId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/instagram/media_publish`,
        {
          creation_id: creationId.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const insertPostComment = createAsyncThunk(
  "instagram/insertPostComment",
  async (data, { rejectWithValue }) => {
    console.log(data, "--------------insertPostComment__________");

    try {
      const response = await axios.post(
        `${BASE_URL}/instagram/addcomment`,
        {
          postid: data?.postId,
          message: data?.message,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response.data, "-------------response.comentadd---");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPostComments = createAsyncThunk(
  "instagram/getPostComments",
  async (postId, { rejectWithValue }) => {
    console.log(postId, "-----------------postId----------------");
    try {
      const response = await axios.get(`${BASE_URL}/instagram/post/${postId}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(
        response.data.data,
        "-----------------commentpostId----------------"
      );
      return { postId: postId, comments: response.data.data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Get comment replies
export const getCommentReplies = createAsyncThunk(
  "instagram/getCommentReplies",
  async (commentId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/instagram/comments/${commentId}/replies`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return {
        commentId,
        replies: response.data.data,
        success: response.data.success
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch replies"
      );
    }
  }
);

export const replyToComment = createAsyncThunk(
  "instagram/replyToComment",
  async ({ commentId, message }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/instagram/comments/${commentId}/replies`, {
        message
      }, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      }
      );
      return {
        commentId,
        reply: response.data.data,
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to post reply"
      );
    }
  }
);

export const hideUnhideComment = createAsyncThunk(
  "instagram/hideUnhideComment",
  async ({ commentId, hide }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/instagram/comments/${commentId}/hide`, {
        hide,
      }, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      },
      );
      return {
        commentId,
        hide,
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update comment visibility"
      );
    }
  }
);


export const toggleMediaComments = createAsyncThunk(
  "instagram/toggleMediaComments",
  async ({ mediaId, commentEnabled }, { rejectWithValue }) => {
    console.log(mediaId, commentEnabled ,"mediaId, commentEnabledmediaId, commentEnabledmediaId, commentEnabled")
    alert('asdasdasasd')
    try {
      const response = await axios.post(
        `${BASE_URL}/instagram/media/${mediaId}/comments/toggle`,
        { commentEnabled },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return {
        mediaId,
        commentEnabled,
        success: response.data.success,
        message: response.data.message,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to toggle media comments"
      );
    }
  }
);


export const deleteComment = createAsyncThunk(
  "instagram/deleteComment",
  async (commentId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/instagram/comments/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      return {
        commentId,
        success: response.data.success,
        message: response.data.message,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete comment"
      );
    }
  }
);



export const igDisconnect = createAsyncThunk(
  "instagram/disconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/ig/disconnect`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const igProfile = createAsyncThunk(
  "instagram/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/instagram/igprofile`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      console.log(
        response.data,
        "----------------igprofile---------------------------"
      );
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const IghandleLogoutAndReLogin = createAsyncThunk(
  "instagram/IghandleLogoutAndReLogin",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/user/instagram/logout/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(
        response
        // "----------------igprofile---------------------------"
      );
      return response; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getIgstories = createAsyncThunk(
  "instagram/getIgstories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/instagram/igstories`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });

      console.log(
        response.data.data.data,
        "----------------getIgstories---------------------------"
      );
      return response.data.data.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
